//Built in Libraries
import type { ReactNode } from 'react';

import useAccessControl from '../../../hooks/useAccessControl';
import type { PermissionCommons } from '../../../types/Permission';
import { HasPermission } from '../../Permission/HasPermission';
import SimpleDropDown, { DropDownItem, type direction } from '../SimpleDropDown';

export interface DropDownMenuItem {
  name: string;
  clicked: () => void;
  icon?: React.ReactNode;
  permission?: PermissionCommons;

  // ! Deprecated
  // ? use permission instead
  access?: string[];
}
export interface DropDownProps {
  menuItems: DropDownMenuItem[];
  children: ReactNode;
  wrap?: boolean;
  dropDownDirection?: direction;
}
export default function DropDown({ menuItems, children, dropDownDirection }: DropDownProps) {
  // ! Deprecated
  // ? use permission instead
  const accessControl = useAccessControl();
  return (
    <SimpleDropDown toggle={children} direction={dropDownDirection}>
      {menuItems.map((item) => {
        const { permission } = item;

        const dropDownItem = (
          <DropDownItem id={item.name} onClick={item.clicked} key={item.name}>
            {item.icon}
            {item.name}
          </DropDownItem>
        );
        if (permission) {
          return (
            <HasPermission key={item.name} of={permission.of}>
              {dropDownItem}
            </HasPermission>
          );
        }
        if (!permission && !item.access) {
          return dropDownItem;
        }
        // ! Deprecated
        // ? use permission instead
        if (!permission && item.access && accessControl.canAccess(item.access)) {
          return <div key={item.name}>{dropDownItem}</div>;
        }
        return dropDownItem;
      })}
    </SimpleDropDown>
  );
}
